import React from 'react';
import './UserManagement.css';
import AdminPageLayout from '../../components/AdminPageLayout/AdminPageLayout';

const UserManagement = () => {
  return (
    <AdminPageLayout rootPath="/user-management" className="user-management" />
  );
};

export default React.memo(UserManagement);
